#!/usr/bin/env node
import { main } from "./src/index";
main();
